import React, { useReducer } from 'react';
import Input from '../shared/Inputs';
import DashboardSubscribe from '../../../../assets/images/dashboard-subscribe.png';

const formReducer = (state, event) => {
	return {
		...state,
		[event.name]: event.value,
	};
};

const SidebarContainer = ({
	current_user,
	current_user_img,
	current_user_org,
	current_user_org_img,
	current_user_can_access_client_org,
	current_user_client_orgs,
	is_subscribed,
	subscription_id,
	organization,
}) => {
	const [formData, setFormData] = useReducer(formReducer, { email: '' });

	const handleChange = (event) => {
		setFormData({
			name: event.target.name,
			value: event.target.value,
		});
	};

	const redirectToOrgCampaigns = () => {
		location.assign(
			`/organizations/${organization.slug}?tab=opportunities`
		);
	};

	return (
		<>
			<div className="card my-profile-details-container">
				<div className="text-right">
					<a href="/users/edit">
						<i className="fa fa-edit"></i>
					</a>
				</div>
				<div className="text-center">
					<div className="profile-pic-container">
						<img src={current_user_img} />
					</div>
					<div className="font-medium-large">
						<strong>
							{current_user.first_name +
								' ' +
								current_user.last_name}
						</strong>
					</div>
					{current_user.title}
					<div className="contact-details-container">
						<div className="contact-content">
							{current_user.linked_in_profile ? (
								<a
									href={current_user.linked_in_profile}
									target="_blank"
								>
									<i className="fab fa-linkedin"></i>
									{' ' + current_user.linked_in_profile}
								</a>
							) : (
								<>
									<i className="fab fa-linkedin"></i>
									<span> N/A</span>
								</>
							)}
						</div>
						<div className="contact-content">
							<a href={'mailto:' + current_user.email}>
								<i className="fas fa-at"></i>
								{' ' + current_user.email}
							</a>
						</div>
						<div className="contact-content">
							{current_user.phone_number ? (
								<a href={'tel:' + current_user.email}>
									<i className="fas fa-phone-alt"></i>
									{' ' + current_user.phone_number}
								</a>
							) : (
								<>
									<i className="fas fa-phone-alt"></i>
									N/A
								</>
							)}
						</div>
					</div>
				</div>
				{current_user_org ? (
					<div className="organization-container">
						<div className="edit-icon text-right">
							<a
								href={
									'/organizations/' +
									current_user_org.slug +
									'/edit'
								}
							>
								<i className="fa fa-edit"></i>
							</a>
						</div>
						<div className="text-center">
							<a href={'/organizations/' + current_user_org.slug}>
								<div className="image-container">
									<img
										src={
											current_user_org_img ==
											'default-organization.png'
												? defaultImg
												: current_user_org_img
										}
									/>
								</div>
								<strong>
									{current_user_org.legal_name
										? current_user_org.legal_name
										: current_user_org.operating_name}
								</strong>
							</a>
						</div>
					</div>
				) : null}

				{!current_user_org ? (
					<a className="primary-button" href="/attach">
						<p className="sidebar-text">
							<i className="fa fa-plus"></i> Add public profile
						</p>
					</a>
				) : current_user_can_access_client_org ? (
					<a
						className="secondary-button button-sm"
						href={
							'/organizations/' +
							current_user_org.slug +
							'/agency_clients'
						}
					>
						<i className="fa fa-plus"></i> Add client organization
					</a>
				) : null}

				{current_user_can_access_client_org ? (
					<div className="client-organizations-container text-center font-medium-large">
						<strong>Client organizations</strong>
						{current_user_client_orgs.map((org) => {
							return (
								<div
									className="client-organization"
									key={org.id}
								>
									<a href={'/organizations/' + org.slug}>
										{org.legal_name
											? org.legal_name
											: org.operating_name}
									</a>
								</div>
							);
						})}
					</div>
				) : null}
			</div>

			{current_user_org ? (
				<div className="card subscribe-container text-center">
					<p className="sidebar-text">
						Share your campaigns with potential partners
					</p>
					<div className="primary-button">
						<input
							type="submit"
							value="Go to my opportunites"
							className="button"
							onClick={() => redirectToOrgCampaigns()}
						/>
					</div>
				</div>
			) : (
				<></>
			)}

			{!is_subscribed ? (
				<div className="card subscribe-container text-center">
					<img src={DashboardSubscribe} />
					<p className="sidebar-text">
						Subscribe now for exclusive content and recommendations
					</p>
					<div className="purchase-button">
						<a href={'/accounts'}>
							<p className="purchase-button">SUBSCRIBE NOW</p>
						</a>
					</div>
				</div>
			) : null}
			<div className="card subscribe-container text-center">
				<form action="/invitations" method="post">
					<p className="sidebar-text">
						Invite someone to join Sponsor Circle
					</p>
					<Input
						inputType="invitation[email]"
						type="email"
						placeholder="email@example.com"
						data={formData}
						onChange={handleChange}
					/>
					<div className="primary-button">
						<input
							type="submit"
							value="Invite a user"
							className="button"
						/>
					</div>
				</form>
			</div>
		</>
	);
};

export default SidebarContainer;
